import {Stack} from 'shells/layout/stack/stack';

import type {
    GetSharedInboxConfig_sharedInboxConfig as SharedInboxConfig,
    GetSharedInboxConfig_sharedInboxConfig_sharedAddresses as SharedAddress,
} from 'nutshell-graphql-types';

import {ForwardingSection} from './forwarding-section';
import {ReplyingSection} from './replying-section';
import {useForwardingVerification} from './use-forwarding-verification';

interface EmailAddressSettingsProps {
    sharedInboxConfig: SharedInboxConfig;
    sharedAddress: SharedAddress | null;
    onEntriComplete: () => void;
}

export function EmailAddressSettings(props: EmailAddressSettingsProps) {
    const emailAddress = props.sharedAddress?.emailAddress.address;
    const nutshellAddress = props.sharedInboxConfig.nutshellAddress.email.address;
    const isForwardingVerified = Boolean(props.sharedAddress?.forwardingVerifiedTime);
    const forwardingVerifiedTime = props.sharedAddress?.forwardingVerifiedTime ?? null;

    const domain = emailAddress ? emailAddress.split('@')[1] : null;
    const fromDomain = props.sharedAddress?.fromDomain ?? null;

    const {verificationState, handleSendTestEmail, isSending} = useForwardingVerification(
        emailAddress,
        forwardingVerifiedTime
    );

    return (
        <div className='full-width pad-16 overflow-auto background-offwhite'>
            <div className='br-8 background-white pad-16 overflow-hidden'>
                <Stack spacing={16}>
                    <ForwardingSection
                        emailAddress={emailAddress}
                        nutshellAddress={nutshellAddress}
                        isVerified={isForwardingVerified}
                        verificationState={verificationState}
                        onSendTestEmail={handleSendTestEmail}
                        isSending={isSending}
                    />
                    <ReplyingSection
                        emailAddress={emailAddress}
                        domain={domain}
                        fromDomain={fromDomain}
                        onEntriComplete={props.onEntriComplete}
                    />
                </Stack>
            </div>
        </div>
    );
}
